module.exports = __webpack_public_path__ + "static/media/robot.856d230d.jpeg";